import "./App.css";
import "./tailwind.css";
import Header from "./components/header";
import Footer from "./components/footer";
import RoutesPath from "./containers/RoutesPath";
import { useState, useEffect } from "react";
import DisplayMessage from "./components/displayMessage";
import CookieConsent from "./components/cookieConsent";
import SeoManager from "./components/seo/SeoManager";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./helpers/analytics";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const location = useLocation();

  useEffect(() => {
    if (!window.__PRERENDER__) document.documentElement.removeAttribute("data-prerender");
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!isOnline) {
      DisplayMessage(
        "Vous êtes hors ligne. Certaines fonctionnalités peuvent ne pas être disponibles",
        "linear-gradient(to right, #b90909, #b90908)"
      );
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [isOnline]);

  return (
    <>
      <SeoManager />
      <CookieConsent />
      <div className="App">
        <a className="skip-link" href="#main-content">Aller au contenu</a>
        <Header />
        <main id="main-content" tabIndex="-1">
          <RoutesPath />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
